import gql from "graphql-tag";
import PostReplyFields from "../../fragments/engagement/PostReplyFields";

export default gql`
  mutation ReplyToPost($postId: ID!, $bodyAsJson: JSON!, $bodyAsPlainText: String!) {
    replyToPost(postId: $postId, bodyAsJson: $bodyAsJson, bodyAsPlainText: $bodyAsPlainText) {
      ...PostReplyFields
    }
  }

  ${PostReplyFields}
`;
